import { render, staticRenderFns } from "./realTimeVideoYingyan.vue?vue&type=template&id=28359bf3&scoped=true&"
import script from "./realTimeVideoYingyan.vue?vue&type=script&lang=js&"
export * from "./realTimeVideoYingyan.vue?vue&type=script&lang=js&"
import style0 from "./realTimeVideoYingyan.vue?vue&type=style&index=0&id=28359bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28359bf3",
  null
  
)

export default component.exports